import router from "@/router";
import store from "@/store";
router.beforeEach((to, from, next) => {
  next();
  // const token = localStorage.getItem('AuthorizationToken');
  // if (token) {
  //   if (!store.getters.userInfo) {
  //     store.dispatch('getUserInfo').then(res => {
  //       if (to.path == '/login') {
  //         next("/home");
  //       } else {
  //         next({ ...to, replace: true });
  //       }
  //     }).catch((res) => {
  //       store.dispatch('loginOut').then(() => {
  //         next({ path: '/login' })
  //       }).catch((res) => {
  //         next({ path: '/login' })
  //       })
  //     })
  //   } else {
  //     next();
  //   }
  // } else {
  //   if (to.path === '/login') {
  //     next();
  //   } else {
  //     next('/login')
  //   }
  // }
})